import Api_Usermanagement from '../api-usermanagement'
import Api_Masterdata from '../api-masterdata'
import { id } from 'date-fns/locale'

const api = new Api_Usermanagement().init()
const apiMasterData = new Api_Masterdata().init()

const getSipDetail = (id, credential) => {
  return api.get(`/sip_order/detail-sip-approved/${id}?credentials=${credential}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
  }
  
const getDetailItemSIP = (id, credentials) => {
  return api.get(`/order-submission/child-detail/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      'X-Credentials': credentials,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getKontrakAll = (credential, filter, cus) => {
  return api.get(
    `/contract?credentials=${credential}&po_number_orderby=${filter}&customer_name_orderby=${cus}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getAttachment = (id, credential) => {
  return api.get(`/attachment/all/header?attach_parent=${id}&credentials=${credential}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getKontrakDetail = (id, credential, amandement) => {
  return api.get(
    `/contract/detail/${id}?credentials=${credential}${amandement ? '&is_amendment=true' : ''}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getChildDetail = (id) => {
  return api.get(`/order-submission/child-detail/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getSchedule = (id) => {
  return api.get(`/order-submission/schedule/all/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getFileBox = (id, credential) => {
  return api.get(`/attachment/all/contract?attach_parent=${id}&credentials=${credential}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getSipNumber = (credential) => {
  return api.get(`/sip_order/sip-approved?credentials=${credential}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getSipNumberSearch = (credential, sip, name, id, type) => {
  return api.get(
    `/sip_order/sip-approved?credentials=${credential}&SIP_number=${sip}&customer_name=${name}&sector_id=${id}&product_type=${type}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getShow = (id, credential) => {
  return api.get(`/sip_order/detail/${id}?credentials=${credential}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getKontrakDetails = (id, credential) => {
  return api.get(`/contract/detail/${id}?credentials=${credential}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const approve = (id, credential, lang) => {
  return api.post(`/contract/approve/${id}/${lang}?credentials=${credential}`, undefined, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const resubmitContract = (id, data, credential) => {
  return api.put(`/contract/resubmit/${id}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
      'X-Credentials': credential
    },
  })
}

const reject = (id, note) => {
  return api.post(`/contract/revision/${id}?revision_note=${note}`, undefined, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getApproved = (credential) => {
  return api.get(`/contract/contract-number-approved?credentials=${credential}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getApprovedSearch = (credential, kontrak, name, id, sap, ptype) => {
  return api.get(
    `/contract/contract-number-approved?credentials=${credential}&contract_number=${kontrak}&customer_name=${name}&sector_id=${id}&sap_number=${sap}&product_type=${ptype}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getAccesses = (id) => {
  return api.get(`/role-access/detail/${id}/134`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const postAttachment = (data) => {
  return api.post(`/attachment/create/contract`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getKontrakSearch = (
  credential,
  kontrak,
  sip,
  date,
  date2,
  anper,
  cust,
  quantum,
  status,
  regarding,
  sector,
  sap,
  sales_org_code,
  grand_total,
  validity_date_from,
  validity_date_to,
  po_number,
  product_type,
  payment_type
) => {
  return api.get(
    `/contract?credentials=${credential}&contract_number=${kontrak}&sip_number=${sip}&from_date=${date}&to_date=${date2}&sales_org_name=${anper}&customer_name=${cust}&total_quantum=${quantum}&status=${status}&regarding=${regarding}&sector_id=${sector}&sap_number=${sap}&sales_org_code=${sales_org_code}&grand_total=${grand_total}&validity_date_from=${validity_date_from}&validity_date_to=${validity_date_to}&po_number=${po_number}&product_type=${product_type}&payment_type=${payment_type}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getKontrakApprovalSearch = (
  credential,
  kontrak,
  sip,
  date,
  date2,
  anper,
  cust,
  quantum,
  price,
  est_date,
  status,
  regarding,
  checked = ''
) => {
  return api.get(
    `/contract/get-otorisator${checked}?credentials=${credential}&contract_number=${kontrak}&sip_number=${sip}&from_date=${date}&to_date=${date2}&sales_org_name=${anper}&customer_name=${cust}&total_quantum=${quantum}&total_price=${price}&estimate_date=${est_date}&status=${status}&regarding=${regarding}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getKontrakApproval = (credential, filter, cus, checked = '') => {
  return api.get(
    `/contract/get-otorisator${checked}?credentials=${credential}&po_number_orderby=${filter}&customer_name_orderby=${cus}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getConfigLetter = (credential) => {
  return api.get(`contract/config?${credential}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const sentToSAP = (id) => {
  return api.post(
    `/contract/resend-to-sap/${id}`,
    {credentials: localStorage.getItem('credential')},
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const contrakEdit = (id, credential) => {
  return api.post(`/contract/update-amendment/${id}?credentials=${credential}`, undefined, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const syncKontrak = (data) => {
  return api.put(`/contract/sync`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getCustomer = (sales, code, name, dist) => {
  return apiMasterData.get(
    `/customer?sales_org_code=${sales}&customer_code=${code}&name=${name}&distribution_channel=${dist}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const resubmitAdditionalText = (id, data) => {
  return api.put(
    `/contract/update-additional-text/${id}?credentials=${localStorage.getItem('credential')}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getCommentContract = (id) => {
  return api.get(
    `/comment/${id}/contract_notes?credentials=${localStorage.getItem('credential')}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const downloadDraft = (id, lang) => {
    return api.get(`/contract/download/loc/${id}?lang=${lang}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    })
}

export {
  getKontrakAll,
  getAttachment,
  getKontrakDetail,
  getChildDetail,
  getSchedule,
  getFileBox,
  getSipNumber,
  getShow,
  getKontrakDetails,
  approve,
  reject,
  getApproved,
  getKontrakApproval,
  getAccesses,
  getKontrakSearch,
  postAttachment,
  getKontrakApprovalSearch,
  getSipNumberSearch,
  getApprovedSearch,
  getConfigLetter,
  sentToSAP,
  contrakEdit,
  syncKontrak,
  getCustomer,
  resubmitAdditionalText,
  getCommentContract,
  getSipDetail,
  getDetailItemSIP,
  resubmitContract,
  downloadDraft
}
